module.exports = __webpack_public_path__ + "static/media/Malzahar.be75f1b2.png";